import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyledTextField from '../common/StyledTextField';
import './PasswordInput.scss';
var uppercaseRegex = /([A-Z]+)/;
var eightCharsRegex = /(^.{8,}$)/;
var oneNumberRegex = /([0-9]+)/;
function ListItem(_ref) {
  var completed = _ref.completed,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("li", {
    className: "".concat(completed ? 'completed-item' : 'uncompleted-item', " body-text-3")
  }, children);
}
ListItem.propTypes = {
  completed: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
function FormItem(_ref2) {
  var withError = _ref2.withError,
    children = _ref2.children;
  if (!withError) {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "field_with_errors"
  }, children);
}
FormItem.propTypes = {
  withError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
var PasswordInput = /*#__PURE__*/function (_Component) {
  function PasswordInput(props) {
    var _this;
    _classCallCheck(this, PasswordInput);
    _this = _callSuper(this, PasswordInput, [props]);
    _this.state = {
      validUpper: true,
      validEightChars: true,
      validOneNumber: true,
      showPassword: false
    };
    _this.validatePassword = _this.validatePassword.bind(_this);
    _this.toggleShow = _this.toggleShow.bind(_this);
    return _this;
  }
  _inherits(PasswordInput, _Component);
  return _createClass(PasswordInput, [{
    key: "validatePassword",
    value: function validatePassword(event) {
      var handleChange = this.props.handleChange;
      var input = event.target.value;
      this.setState({
        validUpper: uppercaseRegex.test(input),
        validEightChars: eightCharsRegex.test(input),
        validOneNumber: oneNumberRegex.test(input)
      }, handleChange(event));
    }
  }, {
    key: "toggleShow",
    value: function toggleShow(e) {
      e.preventDefault();
      this.setState({
        showPassword: !this.state.showPassword
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        validUpper = _this$state.validUpper,
        validEightChars = _this$state.validEightChars,
        validOneNumber = _this$state.validOneNumber,
        showPassword = _this$state.showPassword;
      var _this$props = this.props,
        errors = _this$props.errors,
        autoFocus = _this$props.autoFocus,
        title = _this$props.title,
        id = _this$props.id,
        type = _this$props.type,
        tabIndex = _this$props.tabIndex,
        labelAbove = _this$props.labelAbove;
      if (labelAbove) {
        return /*#__PURE__*/React.createElement("div", {
          id: "password-input",
          className: "mb-3"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: id,
          className: "form-label"
        }, title), /*#__PURE__*/React.createElement("div", {
          className: "password-field-wrapper"
        }, /*#__PURE__*/React.createElement(FormItem, {
          withError: errors
        }, /*#__PURE__*/React.createElement("input", {
          id: id,
          type: showPassword ? 'text' : 'password',
          name: "user[password]",
          className: "form-control".concat(errors ? ' is-invalid' : ''),
          onChange: this.validatePassword,
          tabIndex: tabIndex,
          autoFocus: autoFocus /* eslint-disable-line jsx-a11y/no-autofocus */
        })), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "password-eye-btn",
          onClick: this.toggleShow,
          "aria-label": showPassword ? 'Hide password' : 'Show password'
        }, /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          "aria-hidden": "true"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
        }), /*#__PURE__*/React.createElement("circle", {
          cx: "12",
          cy: "12",
          r: "3"
        })))), /*#__PURE__*/React.createElement("a", {
          href: "#",
          className: "show-hide-btn body-text-3 normal-weight mb-2 text-decoration-none",
          onClick: this.toggleShow
        }, showPassword ? 'Hide password' : 'Show password'));
      }
      return /*#__PURE__*/React.createElement("div", {
        id: "password-input"
      }, /*#__PURE__*/React.createElement(FormItem, {
        withError: errors
      }, /*#__PURE__*/React.createElement(StyledTextField, {
        id: id,
        className: "form-control",
        name: "user[password]",
        label: title,
        type: !showPassword ? 'password' : 'text',
        onChange: this.validatePassword,
        tabIndex: tabIndex,
        autoFocus: autoFocus,
        error: errors
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row ".concat(type === 'new' && !(validUpper && validEightChars && validOneNumber) ? 'g-flex-justify-space-between' : 'g-row-justify-right')
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "show-hide-btn body-text-3 normal-weight mb-2 text-decoration-none",
        onClick: this.toggleShow
      }, showPassword ? 'Hide password' : 'Show password'), type === 'new' && [!(validUpper && validEightChars && validOneNumber) ? /*#__PURE__*/React.createElement("ul", {
        className: "validations-list",
        key: "0"
      }, /*#__PURE__*/React.createElement(ListItem, {
        completed: validUpper
      }, " One uppercase "), /*#__PURE__*/React.createElement(ListItem, {
        completed: validEightChars
      }, " 8 characters minimum "), /*#__PURE__*/React.createElement(ListItem, {
        completed: validOneNumber
      }, " One number ")) : null]));
    }
  }]);
}(Component);
PasswordInput.propTypes = {
  errors: PropTypes.bool.isRequired,
  autoFocus: PropTypes.bool,
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  tabIndex: PropTypes.string,
  handleChange: PropTypes.func,
  labelAbove: PropTypes.bool
};
PasswordInput.defaultProps = {
  autoFocus: false,
  id: 'user_password',
  type: 'new',
  tabIndex: null,
  handleChange: function handleChange() {},
  labelAbove: false
};
export default PasswordInput;